import React from 'react'

import { AdminContext } from 'contexts/AdminContext'
import { Link } from 'react-router-dom'

import {
  AiOutlineBell,
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineCopyrightCircle,
  AiOutlineDollarCircle,
  AiOutlineLoading3Quarters,
  AiOutlineLogout,
  AiOutlineMenu,
  AiOutlineUser
} from 'react-icons/ai'

import { CodigosTransaccionesConstant } from 'constants/index'

import { TipoCambioModal } from 'sharedComponents/modals'

import * as BackgroundJobsService from 'services/backgroundJobs.service'

const AppHeader = () => {
  const __adminContext = React.useContext(AdminContext)

  const [mostrarTipoCambioModal, setMostrarTipoCambioModal] = React.useState(false)
  const [jobs, setJobs] = React.useState([])
  const [mostrarJobsDropdown, setMostrarJobsDropdown] = React.useState(false)

  React.useEffect(() => {
    const fetchJobs = () => {
      BackgroundJobsService.obtenerPendientes()
        .then(({ data }) => setJobs(data || []))
        .catch(() => {})
    }

    fetchJobs()
    const interval = setInterval(fetchJobs, 10000)
    return () => clearInterval(interval)
  }, [])

  const jobsFinalizados = jobs.filter(j => j.estado !== 'EN_PROCESO')
  const jobsEnProceso = jobs.filter(j => j.estado === 'EN_PROCESO')

  const clickToggleSidebar = e => {
    e.preventDefault()

    const nodoBody = document.body
    nodoBody.classList.toggle('sidebar-hide')
  }

  const clickTipoCambio = React.useCallback(e => {
    e.preventDefault()
    setMostrarTipoCambioModal(true)
  }, [])

  const clickBell = React.useCallback(e => {
    e.preventDefault()
    setMostrarJobsDropdown(prev => !prev)
  }, [])

  const clickMarcarTodosVistos = React.useCallback(() => {
    BackgroundJobsService.marcarTodosVistos()
      .then(() => {
        setJobs(prev => prev.filter(j => j.estado === 'EN_PROCESO'))
        setMostrarJobsDropdown(false)
      })
      .catch(() => {})
  }, [])

  React.useEffect(() => {
    if (!mostrarJobsDropdown) return
    const handleClick = () => setMostrarJobsDropdown(false)
    const timer = setTimeout(() => document.addEventListener('click', handleClick), 100)
    return () => {
      clearTimeout(timer)
      document.removeEventListener('click', handleClick)
    }
  }, [mostrarJobsDropdown])

  return (
    <>
      <div className='app-header'>
        <div className='cner-fluid'>
          <div className='d-flex'>
            <a className='app-sidebar__toggle' href='#!' onClick={clickToggleSidebar}>
              <AiOutlineMenu />
            </a>
            <div className='d-flex ml-auto'>
              <div className='header-item header-computer'>
                <Link to={`/${CodigosTransaccionesConstant.COMPUTER_MAIN}`} className='header-nav computer-icon'>
                  <AiOutlineCopyrightCircle />
                </Link>
              </div>
              <div className='header-item header-bell' style={{ position: 'relative' }}>
                <a className='header-nav bell-icon' href='#!' onClick={clickBell}>
                  <AiOutlineBell />
                  {jobs.length > 0 && (
                    <span
                      style={{
                        position: 'absolute',
                        top: '2px',
                        right: '2px',
                        background: jobsEnProceso.length > 0 ? '#ffc107' : '#28a745',
                        color: '#fff',
                        borderRadius: '50%',
                        width: '16px',
                        height: '16px',
                        fontSize: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {jobs.length}
                    </span>
                  )}
                </a>
                {mostrarJobsDropdown && (
                  <div
                    onClick={e => e.stopPropagation()}
                    style={{
                      position: 'absolute',
                      top: '100%',
                      right: 0,
                      width: '320px',
                      maxHeight: '400px',
                      overflowY: 'auto',
                      background: '#fff',
                      border: '1px solid #e0e0e0',
                      borderRadius: '4px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                      zIndex: 1000
                    }}
                  >
                    <div style={{ padding: '8px 12px', borderBottom: '1px solid #e0e0e0', fontWeight: 'bold', fontSize: '13px' }}>
                      Procesos en background
                    </div>
                    {jobs.length === 0 && (
                      <div style={{ padding: '12px', color: '#999', fontSize: '12px', textAlign: 'center' }}>
                        Sin procesos pendientes
                      </div>
                    )}
                    {jobs.map(job => (
                      <div
                        key={job._id}
                        style={{
                          padding: '8px 12px',
                          borderBottom: '1px solid #f0f0f0',
                          fontSize: '12px',
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '8px'
                        }}
                      >
                        <span style={{ marginTop: '2px', flexShrink: 0 }}>
                          {job.estado === 'EN_PROCESO' && <AiOutlineLoading3Quarters style={{ color: '#ffc107', animation: 'spin 1s linear infinite' }} />}
                          {job.estado === 'COMPLETADO' && <AiOutlineCheckCircle style={{ color: '#28a745' }} />}
                          {job.estado === 'ERROR' && <AiOutlineCloseCircle style={{ color: '#dc3545' }} />}
                        </span>
                        <div>
                          <div style={{ fontWeight: 500 }}>{job.nombre}</div>
                          <div style={{ color: '#666', marginTop: '2px' }}>{job.mensaje || job.progreso || ''}</div>
                        </div>
                      </div>
                    ))}
                    {jobsFinalizados.length > 0 && (
                      <div style={{ padding: '8px 12px', textAlign: 'center' }}>
                        <button
                          onClick={clickMarcarTodosVistos}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            color: '#007bff',
                            cursor: 'pointer',
                            fontSize: '12px'
                          }}
                        >
                          Marcar todo como visto
                        </button>
                      </div>
                    )}
                    <div style={{ padding: '8px 12px', textAlign: 'center', borderTop: '1px solid #f0f0f0' }}>
                      <Link to={`/${CodigosTransaccionesConstant.BACKGROUNDJOBS_MAIN}`} style={{ fontSize: '12px' }}>
                        Ver historial completo
                      </Link>
                    </div>
                  </div>
                )}
              </div>
              <div className='header-item'>
                <a className='header-nav exchange-icon' href='#!' onClick={clickTipoCambio}>
                  <AiOutlineDollarCircle />
                </a>
              </div>
              <div className='header-item header-user'>
                <Link to={`/${CodigosTransaccionesConstant.SELF_PERFIL}`} className='header-nav user-name-icon'>
                  <span className='username'>{__adminContext.usuario}</span>
                  <span>
                    <AiOutlineUser />
                  </span>
                </Link>
              </div>
              <div className='header-item header-logout'>
                <Link to='/logout' className='header-nav logout-icon'>
                  <AiOutlineLogout />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {mostrarTipoCambioModal && (
        <TipoCambioModal show={mostrarTipoCambioModal} handleClose={() => setMostrarTipoCambioModal(false)} />
      )}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  )
}

export default AppHeader
